import Router from './routes/Router';

import '../src/assets/global.scss';

export default function App() {
  return (
    <>
      <Router />
    </>
  );
}
